'use client'

import { Box, Flex, Text, Center, Spacer, Icon, UseToastOptions, useToast as originUseToast } from '@chakra-ui/react'
import { CheckCircleIcon, CloseIcon } from '@chakra-ui/icons'
import { HiExclamationCircle } from 'react-icons/hi'

import React from 'react'

type Props = {} & UseToastOptions

const useToast = () => {
  const t = originUseToast()
  return (props: Props) => {
    props.position = props.position ? props.position : 'top-right'
    return t({
      ...props,
      isClosable: true,
      render: ({ onClose }) => render(props.status, props.title, props.description, onClose),
    })
  }
}

const render = (
  status: UseToastOptions['status'],
  title: React.ReactNode,
  description: React.ReactNode,
  onClose: () => void,
): JSX.Element => {
  return (
    <>
      <Box
        borderRadius={'6px'}
        boxShadow={'0px 10px 15px -3px rgba(0, 0, 0, 0.1)'}
        p={'12px 16px'}
        color={'gray.700'}
        bg={'white'}
      >
        <Flex>
          <Center>{renderIcon(status)}</Center>
          <Center>
            <Box>
              {title && (
                <Text className={'custom-toast-title'} fontSize={'lg'} fontWeight={'bold'}>
                  {title}
                </Text>
              )}
              {description && <Text>{description}</Text>}
            </Box>
          </Center>
          <Spacer />
          <Center>
            <CloseIcon onClick={() => onClose()} cursor="pointer" color="gray.300" />
          </Center>
        </Flex>
      </Box>
    </>
  )
}

const renderIcon = (status: UseToastOptions['status']) => {
  switch (status) {
    case 'success':
      return <Icon as={CheckCircleIcon} color={'green.500'} fontSize={'xl'} mr={'12px'} />
    case 'warning':
      return <Icon as={CheckCircleIcon} color={'orange.500'} fontSize={'xl'} mr={'12px'} />
    case 'error':
      return <Icon as={HiExclamationCircle} color={'red.500'} fontSize={'xl'} mr={'12px'} />
    default:
      return <Icon as={CheckCircleIcon} color={'green.500'} fontSize={'xl'} mr={'12px'} />
  }
}

export default useToast
